import { SHStack, SHTypography } from "@components/design-systems";
import { WarningSVG } from "@components/svgs";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { useTheme } from "@mui/material";
import { memo } from "react";

interface NotDisclosedCellProps {
  analysisData?: MAAnalysisDataDTO;
}

export const NotDisclosedCell = memo(
  ({ analysisData }: NotDisclosedCellProps) => {
    const { palette } = useTheme();
    return (
      <SHStack direction="row" spacing={1} justifyContent="center">
        <SHStack mt={"1px"}>
          <WarningSVG backgroundColor={palette.error[200]} iconColor="white" />
        </SHStack>
        <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
          {analysisData?.value}
        </SHTypography>
      </SHStack>
    );
  },
);
